import { Pipe, PipeTransform } from '@angular/core'
import { ContextWithImplicit } from '@alliance/shared/models'

@Pipe({
  name: 'contextToImplicit'
})
export class ContextToImplicitPipe<T> implements PipeTransform {
  public transform(value: T): ContextWithImplicit<T> {
    return {
      $implicit: value
    }
  }
}
